import { Autocomplete, Box, Button, createFilterOptions, Dialog, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material'
import LinkIcon from '@mui/icons-material/Link';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MonitorIcon from '@mui/icons-material/Monitor';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { api } from 'src/api/endpoints';
import { useDispatch } from 'react-redux';
import { updateScreenScheduler } from 'src/redux/actions/Screen';
import toast from 'react-hot-toast';

const AttachSchedulerDialog = ({open, onClose, screenData, syncScreensByMac}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const {schedulers} = useSelector((state) => state.Scheduler)
    const [selectedScheduler, setSelectedScheduler] = useState(null)

    const schedulesFilterOptions = createFilterOptions({
        ignoreCase: true,
        matchFrom: "start"
    })

    useEffect(() => {
        if(screenData?.scheduler?._id) {
            setSelectedScheduler({
                id: screenData?.scheduler?._id,
                label: screenData?.scheduler?.name
            })
        }
    }, [screenData])

    const handleAttach = async () => {
        try {
            const resp = await api.patch('/scheduler/attachScheduler', {
                screenId: screenData._id,
                schedulerId: selectedScheduler.id
            })

            dispatch(updateScreenScheduler(resp.data?.screen))
            syncScreensByMac([resp.data?.screen.mac])
            setSelectedScheduler(null)
            onClose()
        } catch (err) {
            toast.error(t("views.scheduler.serverErr"))
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle textAlign="center">{t("views.scheduler.attachSchedulerToScreen")}</DialogTitle>
            <DialogContent sx={{
                display: "flex",
                flexDirection: "column",
                gap: '20px',
                mt: 2
            }}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px"
                }}>
                    <MonitorIcon />
                    <Typography>{screenData?.deviceName}</Typography>
                </Box>
                <SwapVertIcon/>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px"
                }}>
                    <CalendarMonthIcon />
                    <Autocomplete
                        filterOptions={schedulesFilterOptions}
                        options={schedulers.map(sch => {
                            return {label: sch.name, id: sch._id}
                        })}
                        value={selectedScheduler}
                        onChange={(event, newValue) => {
                            setSelectedScheduler(newValue)
                        }}
                        renderInput={(params) => <TextField {...params} label={t("views.scheduler.title")} />}
                        sx={{
                            minWidth: "300px"
                        }}
                    />
                </Box>
                <Box>
                    <Button variant='outlined' sx={{
                        mr: 2
                    }} onClick={handleAttach}>{t("views.scheduler.attach")}</Button>
                    <Button variant='outlined' color="error" onClick={onClose}>{t("views.scheduler.cancel")}</Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default AttachSchedulerDialog
